 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"teams":"teams","ChangePassword":"ChangePassword","account~asset~employeeBenefits~onboarding~privateRaise~publicRaise~wallet":"account~asset~employeeBenefits~onboarding~privateRaise~publicRaise~wallet","account~asset~employeeBenefits~onboarding~privateRaise":"account~asset~employeeBenefits~onboarding~privateRaise","account~wallet":"account~wallet","account":"account","apiClient~asset~employeeBenefits~privateRaise":"apiClient~asset~employeeBenefits~privateRaise","asset":"asset","employeeBenefits":"employeeBenefits","privateRaise":"privateRaise","onboarding":"onboarding","overviewDetails~wallet":"overviewDetails~wallet","wallet":"wallet","publicRaise":"publicRaise","apiClient":"apiClient","dashboard~invest~overviewDetails":"dashboard~invest~overviewDetails","dashboard~invest":"dashboard~invest","invest":"invest","overviewDetails":"overviewDetails","dashboard":"dashboard","create roles":"create roles","edit roles":"edit roles","logout":"logout"}[chunkId]||chunkId) + "." + {"chunk-12630aca":"5c7d6b69","chunk-1db172e2":"9c1b71c6","chunk-2d0cbaa3":"7ec215af","chunk-6652ae1e":"9490a1c5","chunk-7f0869f6":"5e3c1bef","teams":"4aa037ff","chunk-2d221fb8":"bfe86d28","chunk-4274cb78":"58ef2064","ChangePassword":"3fe1d55e","account~asset~employeeBenefits~onboarding~privateRaise~publicRaise~wallet":"a31a20c7","account~asset~employeeBenefits~onboarding~privateRaise":"0ae618ae","account~wallet":"bb8c1cbd","account":"a44df12f","apiClient~asset~employeeBenefits~privateRaise":"b17b270a","asset":"d2aba12f","employeeBenefits":"324230e0","privateRaise":"e73a7bac","onboarding":"4051fdb4","overviewDetails~wallet":"254420b9","wallet":"06b59ea4","publicRaise":"8333a461","chunk-006d43e6":"a90d421e","apiClient":"b8647540","chunk-441a3073":"93db7a30","dashboard~invest~overviewDetails":"3cace196","dashboard~invest":"1cf92cea","invest":"9ce9c977","overviewDetails":"00b71efe","dashboard":"57c50aab","chunk-5794e608":"5fefa4d9","chunk-fe3de8da":"43bef2f5","create roles":"968755b0","edit roles":"1a680146","logout":"9032847f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-12630aca":1,"chunk-1db172e2":1,"chunk-6652ae1e":1,"chunk-7f0869f6":1,"teams":1,"ChangePassword":1,"account~asset~employeeBenefits~onboarding~privateRaise~publicRaise~wallet":1,"account~asset~employeeBenefits~onboarding~privateRaise":1,"account~wallet":1,"account":1,"asset":1,"employeeBenefits":1,"privateRaise":1,"onboarding":1,"overviewDetails~wallet":1,"wallet":1,"publicRaise":1,"chunk-006d43e6":1,"apiClient":1,"chunk-441a3073":1,"dashboard~invest~overviewDetails":1,"dashboard~invest":1,"invest":1,"overviewDetails":1,"dashboard":1,"chunk-5794e608":1,"chunk-fe3de8da":1,"create roles":1,"edit roles":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"teams":"teams","ChangePassword":"ChangePassword","account~asset~employeeBenefits~onboarding~privateRaise~publicRaise~wallet":"account~asset~employeeBenefits~onboarding~privateRaise~publicRaise~wallet","account~asset~employeeBenefits~onboarding~privateRaise":"account~asset~employeeBenefits~onboarding~privateRaise","account~wallet":"account~wallet","account":"account","apiClient~asset~employeeBenefits~privateRaise":"apiClient~asset~employeeBenefits~privateRaise","asset":"asset","employeeBenefits":"employeeBenefits","privateRaise":"privateRaise","onboarding":"onboarding","overviewDetails~wallet":"overviewDetails~wallet","wallet":"wallet","publicRaise":"publicRaise","apiClient":"apiClient","dashboard~invest~overviewDetails":"dashboard~invest~overviewDetails","dashboard~invest":"dashboard~invest","invest":"invest","overviewDetails":"overviewDetails","dashboard":"dashboard","create roles":"create roles","edit roles":"edit roles","logout":"logout"}[chunkId]||chunkId) + "." + {"chunk-12630aca":"4959b71c","chunk-1db172e2":"11a4fca3","chunk-2d0cbaa3":"31d6cfe0","chunk-6652ae1e":"dbfc253f","chunk-7f0869f6":"a9d6046b","teams":"394983ea","chunk-2d221fb8":"31d6cfe0","chunk-4274cb78":"31d6cfe0","ChangePassword":"5837910a","account~asset~employeeBenefits~onboarding~privateRaise~publicRaise~wallet":"a53dc9cc","account~asset~employeeBenefits~onboarding~privateRaise":"38c6e0f7","account~wallet":"3f81e41d","account":"a9d02859","apiClient~asset~employeeBenefits~privateRaise":"31d6cfe0","asset":"5cac87e4","employeeBenefits":"7b293184","privateRaise":"e2155de7","onboarding":"5f32a8d7","overviewDetails~wallet":"d375a9fd","wallet":"6311c36e","publicRaise":"3dbb6729","chunk-006d43e6":"62fed1df","apiClient":"d43438bb","chunk-441a3073":"4a6fd600","dashboard~invest~overviewDetails":"dade958e","dashboard~invest":"f2a61f89","invest":"c6a3c681","overviewDetails":"f42d4173","dashboard":"b9887a88","chunk-5794e608":"c0a81b62","chunk-fe3de8da":"0f4d144c","create roles":"fb0af862","edit roles":"03a28b09","logout":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
